<template>
  <div>
    <el-form
      ref="form"
      size="mini"
      class="mb-2"
      :rules="rules"
      :model="formData"
      label-width="100px"
    >
      <el-row :gutter="10" class="mt-3">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_so_salesChannel') || '销售渠道'"
            prop="platformCode"
          >
            <dict-select
              v-model="formData.platformCode"
              url="/ecomorder/ecom/platform/order/platform/select"
              :placeholder="
                $l('tips_select_platform_code_placeholder') || '请选择销售渠道'
              "
              filterable
              size="mini"
              style="width:100%"
              @change="onSalesChannelChnage"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="9">
          <el-form-item
            :label="$l('form_label_so_createDate') || '订单创建时间'"
          >
            <el-date-picker
              size="mini"
              style="width:100%"
              v-model="formData.createDate"
              value-format="yyyy-MM-dd"
              type="daterange"
              :start-placeholder="
                $l('tips_select_create_date_start_placeholder') ||
                  '请选择开始时间'
              "
              :end-placeholder="
                $l('tips_select_create_date_end_placeholder') ||
                  '请选择结束时间'
              "
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            :label="$l('form_label_so_status') || '订单状态'"
            prop="orderStatus"
          >
            <el-select
              v-model="formData.orderStatus"
              size="mini"
              style="width:100%"
              clearable
              :placeholder="
                $l('tips_select_so_status_placeholder') || '请选择订单状态'
              "
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="10">
          <el-form-item
            :label="$l('form_label_so_purchaseOrderId') || '订单号'"
            prop="purchaseOrderId"
          >
            <el-input
              v-model="formData.purchaseOrderId"
              clearable
              :placeholder="
                $l('tips_select_so_purchaseOrderId_placeholder') ||
                  '请填写订单号'
              "
              maxlength="50"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('form_label_so_customerOrderId') || '客户订单号'"
            prop="customerOrderId"
          >
            <el-input
              v-model="formData.customerOrderId"
              clearable
              :placeholder="
                $l('tips_select_so_customerOrderId_placeholder') ||
                  '请填写客户订单号'
              "
              maxlength="50"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4" style="display: flex;justify-content: center;">
          <el-button type="primary" size="mini" @click="query">{{
            $l('btn_so_query') || '查询'
          }}</el-button>
        </el-col>
      </el-row>
    </el-form>
    <OrderTable
      ref="orderTable"
      :tableData="tableData"
      :loading="loading"
      @reload="query"
      @checkboxChange="checkboxChange"
    >
    </OrderTable>
  </div>
</template>
<script>
import OrderTable from './table.vue'
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
import dayjs from 'dayjs'
export default {
  components: { OrderTable },
  mixins: [EditLoading],
  data() {
    return {
      formData: {
        createDateStart: '',
        createDateEnd: '',
        createDate: [],
      },
      tableData: [],
      loading: false,
      rules: {
        platformCode: [
          {
            required: true,
            message:
              this.$l('form_so_pl_title_platformCode') || '请选择销售渠道',
            trigger: 'change',
          },
        ],
      },
      options: [
        {
          value: 'Created',
          label: this.$l('select_value_created') || '新建',
        },
        {
          value: 'Acknowledged',
          label: this.$l('select_value_acknowledged') || '已确认',
        },
        {
          value: 'Shipped',
          label: this.$l('select_value_shipped') || '已发运',
        },
        {
          value: 'Delivered',
          label: this.$l('select_value_delivered') || '已送达',
        },
      ],
    }
  },
  methods: {
    onSalesChannelChnage() {
      this.tableData = []
      this.clearCheckList()
    },
    query() {
      if (!this.formData.platformCode) return
      this.loading = true
      if (this.formData?.createDate && this.formData.createDate?.length) {
        this.formData.createDateStart = this.formData.createDate[0]
        this.formData.createDateEnd = this.formData.createDate[1]
      } else {
        this.formData.createDateStart = ''
        this.formData.createDateEnd = ''
      }
      this.$api
        .ecomPlatformOrderWebOrderListApi({
          ...this.formData,
        })
        .then((res) => {
          this.clearCheckList()
          const tmpData = res.body?.data || []

          this.tableData = this.filterData(tmpData)
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    filterData(data) {
      if (!(data && data?.length)) {
        return []
      }
      if (this.formData.createDateStart && this.formData.createDateEnd) {
        return data.filter((e) => {
          const start = dayjs(this.formData.createDateStart)
            .toDate()
            .getTime()

          const end = dayjs(this.formData.createDateEnd)
            .toDate()
            .getTime()

          const orderDate = dayjs(e.orderDateFormat)
            .toDate()
            .getTime()

          return orderDate >= start && orderDate <= end
        })
      }
      return data
    },
    clearCheckList() {
      this.$refs.orderTable.removeCheckboxRow()
    },
    checkboxChange(data) {
      this.$emit('checkboxChange', data)
    },
    async sync(data) {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      this.loadingOpen()
      const res = await this.$api
        .ecomPlatformOrderSyncOrdersApi({
          platformCode: this.formData.platformCode,
          orgDataList: data,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      this.$message({
        showClose: true,
        message: this.$l('tips_sync_ok') || res.msg,
        type: 'success',
      })
      const { status } = res
      if (status == 200) {
        this.$emit('close')
        this.clearCheckList()
        this.$emit('reload')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
  display: flex;
  align-items: center;
}
</style>
